import { checkToken } from "./utils"

export function getToken() {
  if (checkToken()) {
    return localStorage.getItem("Token");
  }
  else {
    return '';
  }
}
export function getoldToken() {
  return localStorage.getItem("Token");
}

export function getExpireTime() {
  return localStorage.getItem("expires_time");
}

export function setToken(token, time) {
  localStorage.setItem('Token', token)
  localStorage.setItem('expires_time', time)
}

export function removeToken() {
  localStorage.removeItem('Token')
  localStorage.removeItem('expires_time')
}

export function isKeyToken() {
  return Cookies.isKey('Token')
}

/**
 * 设置其他属性于浏览器
 */
export function setcookie(name, value) {
  return localStorage.setItem(name, value)
}

/**
 * 获取其他属性
 */
export function getcookie(name) {
  return localStorage.getItem(name);
}


/**
 * 删除其他属性
 */
export function removecookie(name) {
  return localStorage.removeItem(name)
}



// WEBPACK FOOTER //
// ./src/assets/js/auth.js